<div class="access-denied mx-auto my-4 p-4 rounded border bg-light">
    <h1 class="h3 mb-3">Access denied</h1>

    <p class="lead">
        @if (page(); as page) {
            You don't have access to <code class="text-break">{{ page }}</code>.
        } @else {
            You don't have access to that page.
        }
    </p>

    @switch (denial()?.reason) {
        @case ('module') {
            @if (requirements().length) {
                <p class="mb-2">{{ requirements().length > 1 ? 'It needs one of:' : 'It needs:' }}</p>
                <ul class="list-unstyled mb-0">
                    @for (requirement of requirements(); track $index) {
                        <li class="mb-2">
                            <strong>{{ requirement.modules }}</strong>: {{ requirement.roles }}
                            @if (requirement.current.length) {
                                <div class="text-muted">
                                    Your role:
                                    @for (current of requirement.current; track current.module) {
                                        {{ current.module }}: {{ current.role }}{{ $last ? '' : ';' }}
                                    }
                                </div>
                            }
                        </li>
                    }
                </ul>
            } @else {
                <p class="mb-0">It needs access to at least one module, and your account doesn't have any yet.</p>
            }
            @if (denial()?.message; as message) {
                <p class="text-muted mt-2 mb-0">{{ message }}</p>
            }
        }
        @case ('association') {
            <p class="mb-0">{{ denial()?.message }}</p>
        }
        @case ('server') {
            <p class="mb-0">{{ denial()?.message || 'The server refused a request this page makes.' }}</p>
        }
    }

    <div class="access-denied-actions mt-4">
        <button type="button" class="btn btn-cancel" (click)="goBack()">Go back</button>
        @if (denial()?.alternative; as alternative) {
            <a class="btn btn-save" [routerLink]="alternative.url">{{ alternative.label }}</a>
        }
        @if (canRequestAccess()) {
            <button type="button" class="btn btn-save" (click)="requestAccess()">Request access</button>
        } @else {
            <span class="text-muted">Contact your administrator.</span>
        }
    </div>
</div>
